import { useEffect, useState } from "react";
import { UserCog } from "lucide-react";
import { rpc } from "../../lib/rpc";

const dayMs = 24 * 60 * 60 * 1000;

function daysSince(iso) {
    if (!iso) return null;
    return Math.floor((Date.now() - new Date(iso).getTime()) / dayMs);
}

export default function Ausleihen() {
    const [loans, setLoans] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        rpc.get("/loans").then((r) => {
            if (r.ok) {
                setLoans(r.data);
            } else {
                // Fehler nicht als "keine Ausleihen" tarnen (Review PR #48).
                setError(r.error || "Liste konnte nicht geladen werden.");
                setLoans([]);
            }
        });
    }, []);

    return (
        <section className="flex flex-col gap-4" data-testid="ausleihen-page">
            <div>
                <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">
                    Floor Mode
                </div>
                <h1 className="text-3xl font-bold tracking-tight text-foreground">
                    Ausleihen
                </h1>
                <p className="mt-1 text-xs text-muted-foreground">
                    Wer hat gerade was? Rückgabe wie gewohnt über Scan → Rückgabe.
                </p>
            </div>

            {loans === null ? (
                <div className="text-sm text-muted-foreground">Lade …</div>
            ) : error ? (
                <div
                    className="rounded-xl border border-destructive/50 bg-destructive/10 p-4 text-sm text-destructive"
                    data-testid="ausleihen-error"
                >
                    Ausleihen konnten nicht geladen werden: {error}
                </div>
            ) : loans.length === 0 ? (
                <div className="rounded-xl border border-border bg-card/40 p-6 text-center text-sm text-muted-foreground">
                    Keine offenen Ausleihen.
                </div>
            ) : (
                <ul className="flex flex-col gap-2" data-testid="ausleihen-liste">
                    {loans.map((l) => {
                        const d = daysSince(l.loaned_at);
                        return (
                            <li
                                key={l.asset_id}
                                className="flex items-start gap-3 rounded-lg border border-border bg-card/40 px-3 py-3"
                                data-testid={`ausleihe-${l.asset_id}`}
                            >
                                <UserCog className="mt-0.5 h-5 w-5 shrink-0 text-secondary" />
                                <div className="min-w-0 flex-1">
                                    <div className="truncate text-sm font-medium text-foreground">
                                        {l.article_name || "Unbekannter Artikel"}
                                    </div>
                                    <div className="truncate font-mono text-xs text-muted-foreground">
                                        {l.serial_number || l.asset_tag || "—"}
                                    </div>
                                    <div className="mt-1 text-xs text-foreground">
                                        {l.holder || "—"}
                                    </div>
                                    <div className="text-xs text-muted-foreground">
                                        seit {l.loaned_at ? new Date(l.loaned_at).toLocaleDateString("de-DE") : "—"}
                                        {d != null ? ` (${d} ${d === 1 ? "Tag" : "Tage"})` : ""}
                                    </div>
                                </div>
                                {l.overdue ? (
                                    <span className="rounded-full border border-warning/50 px-2 py-0.5 text-xs font-semibold text-warning">
                                        Überfällig
                                    </span>
                                ) : null}
                            </li>
                        );
                    })}
                </ul>
            )}
        </section>
    );
}
